import React from 'react'
import map from 'lodash/map'
import find from 'lodash/find'
import ScrollingLoader from '@SiteComponents/ScrollingLoader'
import ProjectRow from './ProjectRow'

import {
  IProject,
} from '@SiteModules/Project/types'

import {
  IProjectVersion,
} from '@SiteModules/ProjectVersion/types'

import {
  IOpenRenameProjectPopupPayload,
  IOpenDeleteProjectPopupPayload,
  IOpenSetupProjectPopupPayload,
  IOpenSetupProjectPopupTtsPayload,
} from '@SiteModules/Popup/types'

const COLUMN_COUNT = 8

import './ProjectsTableList.scss'

interface ProjectsTableListProps {
  readonly className: string
  readonly projects: IProject[]
  readonly selectedProjectIds: string[]
  readonly loading: boolean
  readonly hasLoadedAllProjects: boolean
  readonly currentAccountHasCurrentSubscription: boolean
  changeSelectedProjects(e: React.ChangeEvent<HTMLInputElement>, projectId: string): void
  handleForwarding(project: IProject): void
  handleOpenRenameProjectPopup(payload: IOpenRenameProjectPopupPayload): void
  handleOpenDeleteProjectPopup(payload: IOpenDeleteProjectPopupPayload): void
  handleOpenSetupProjectPopup(payload: IOpenSetupProjectPopupPayload): void
  handleOpenSetupProjectPopupTts(payload: IOpenSetupProjectPopupTtsPayload): void
  handleOpenRenewSubscriptionPopup(): void
  handleOpenExportationPopup(projectId: string): void
}

const ProjectsTableList: React.FC<ProjectsTableListProps> = props => {
  const {
    projects,
    selectedProjectIds,
    className,
    loading,
    hasLoadedAllProjects,
    currentAccountHasCurrentSubscription,
  } = props

  const showFooter = !loading && hasLoadedAllProjects

  const renderTableHeader = () => {
    return (
      <tr>
        <th className="ProjectsTableList__check"/>
        <th className="ProjectsTableList__thumbnail-title">
          Name
        </th>
        <th className="ProjectsTableList__status">
          Status
        </th>
        <th className="ProjectsTableList__clips">
          Clips
        </th>
        <th className="ProjectsTableList__languages">
          Languages
        </th>
        <th className="ProjectsTableList__duration">
          Duration
        </th>
        <th className="ProjectsTableList__edited">
          Edited
        </th>
        <th className="ProjectsTableList__created">
          Date of creation
        </th>
        <th className="ProjectsTableList__more"/>
      </tr>
    )
  }

  const tableRows = map(projects, (project, index) => {
    const selected = selectedProjectIds.includes(project.id)
    const originalProjectVersion = find(project.projectVersions, projectVersion => !projectVersion.attributes.isRepurposed) as IProjectVersion

    return (
      <ProjectRow
        key={project.id}
        index={index}
        project={project}
        originalProjectVersion={originalProjectVersion}
        changeSelectedProjects={props.changeSelectedProjects}
        selected={selected}
        handleForwarding={props.handleForwarding}
        currentAccountHasCurrentSubscription={currentAccountHasCurrentSubscription}
        handleOpenRenameProjectPopup={props.handleOpenRenameProjectPopup}
        handleOpenDeleteProjectPopup={props.handleOpenDeleteProjectPopup}
        handleOpenSetupProjectPopup={props.handleOpenSetupProjectPopup}
        handleOpenSetupProjectPopupTts={props.handleOpenSetupProjectPopupTts}
        handleOpenRenewSubscriptionPopup={props.handleOpenRenewSubscriptionPopup}
        handleOpenExportationPopup={props.handleOpenExportationPopup}
      />
    )
  })

  const renderLoader = () => {
    return (
      <tr>
        <td colSpan={COLUMN_COUNT}>
          <ScrollingLoader scale={0.5}/>
        </td>
      </tr>
    )
  }

  const renderFooter = () => {
    return (
      <React.Fragment>
        <tr className="ProjectsTableList__line-container">
          <td colSpan={COLUMN_COUNT} className="ProjectsTableList__line"/>
        </tr>
        <tr>
          <td colSpan={COLUMN_COUNT} className="ProjectsTableList__footer">
            You've reached the end of the list.
          </td>
        </tr>
      </React.Fragment>
    )
  }

  return (
    <div className={className}>
      <table>
        <thead>
          {renderTableHeader()}
        </thead>
        <tbody className="ProjectsTableList__body">
          {tableRows}
          {loading && renderLoader()}
          {showFooter && renderFooter()}
        </tbody>
      </table>
    </div>
  )
}

export default ProjectsTableList
